// extracted by mini-css-extract-plugin
export default {"badgeContainer":"BadgeContainer_badgeContainer__67uAo"};